export const ArrowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.68141e-08 10.59L4.63563 6L1.26284e-07 1.41L1.42713 1.70183e-08L7.5 6L1.42713 12L1.68141e-08 10.59Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TdsArrowIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="arrow-up">
        <path
          id="symbol"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.08578L19.7071 10.7929L18.2929 12.2071L13 6.91421V20.5H11V6.91421L5.70712 12.2071L4.29291 10.7929L12 3.08578Z"
          fill="#131416"
        />
      </g>
    </svg>
  );
};
